// extracted by mini-css-extract-plugin
export default {"container":"Option_container__He2Zg","heading":"Option_heading__wo5MC","inp":"Option_inp__XG1iv","close":"Option_close__G5jAh"};